// import Cookies from 'js-cookie';

class LogoAnimCookie {
  constructor() {
    window.removeEventListener('logo-anim-done', this.onAnimationDone);
    window.addEventListener('logo-anim-done', this.onAnimationDone);
  }

  destroy = () => {
    window.removeEventListener('logo-anim-done', this.onAnimationDone);
  };

  onAnimationDone = () => {
    fetch('/api/cookie/logo-animation');
  };
}

export default (node, props) => new LogoAnimCookie(node, props);
